export type BodySizeOption = {
  label: string;
  code: number;
};

export const BODY_SIZE_OPTIONS: BodySizeOption[] = [
  { label: '44이하', code: 1 },
  { label: '44반', code: 2 },
  { label: '55', code: 3 },
  { label: '55반', code: 4 },
  { label: '66', code: 5 },
  { label: '66반', code: 6 },
  { label: '77', code: 7 },
  { label: '77반', code: 8 },
  { label: '88', code: 9 },
  { label: '88반', code: 10 },
  { label: '99이상', code: 11 },
];

export const HEIGHT_RANGE = { min: 140, max: 190, default: 160 };
export const WEIGHT_RANGE = { min: 40, max: 90, default: 54 };
export const BOTTOM_SIZE_RANGE = { min: 20, max: 40, default: 24 };
export const SHOES_SIZE_RANGE = { min: 210, max: 300, step: 5, default: 240 };

export const TOP_SIZE_DEFAULT_CODE = 3; // SIZE55

export const MAX_SKIN_PROBLEMS = 3;

/**
 * picker / button 양쪽에서 양 끝값에 "이하"/"이상" 표기를 붙이는 헬퍼.
 * 단위 유무와 무관하게 항상 공백 1칸 (네이티브 iOS 컨벤션 일치).
 */
export const formatRangeBoundary = (
  v: number,
  min: number,
  max: number,
  unit: string,
) => {
  if (v === min) return `${v}${unit} 이하`;
  if (v === max) return `${v}${unit} 이상`;
  return `${v}${unit}`;
};
